import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { format } from "date-fns"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

interface FormatCurrencyOptions {
  currency?: {
    code: string
    symbol: string
  }
  minimumFractionDigits?: number
  maximumFractionDigits?: number
  showSymbol?: boolean
  showCode?: boolean
}

export function formatCurrency(
  amount: number,
  options: FormatCurrencyOptions = {}
): string {
  const {
    currency = { code: 'USD', symbol: '$' },
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    showSymbol = true,
    showCode = false,
  } = options

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits,
    maximumFractionDigits,
  })

  const formattedAmount = formatter.format(Math.abs(amount))
  const parts: string[] = []

  if (showSymbol && currency.symbol) {
    parts.push(currency.symbol)
  }

  parts.push(formattedAmount)

  if (showCode && currency.code) {
    parts.push(currency.code)
  }

  return `${amount < 0 ? '-' : ''}${parts.join(' ')}`
}

export function formatDate(date: Date): string {
  return format(date, 'PPP')
}